export default __webpack_public_path__ + "static/media/wallet.5eee3cfc.svg";